/* app/js/src/components/layouts/zone-editor/zone-editor.component.scss */
.field {
  padding-top: 13px;
}
.field.dimension {
  margin-bottom: 13px;
}
.field label {
  color: #7d8fa1;
}
.field .type-dropdown {
  width: 115px;
  height: 21px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  text-align-last: center;
}
.field .type-dropdown:focus-visible {
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  outline: none;
}
.container {
  border-top: 1px solid #f1f3f4;
  padding: 20px;
}
.container .media-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 230px;
  cursor: pointer;
}
.container .media-name:hover {
  text-decoration: underline;
}
.container .buttons {
  text-align: right;
  float: right;
}
.container .buttons evrideo-x-button {
  width: 15px;
  height: 15px;
  display: inline-block;
}
.container evrideo-time-editor {
  display: inline-block;
}
.container label {
  width: 72px;
  font-size: 12px;
  display: inline-block;
}
input[type=checkbox] {
  cursor: pointer;
  accent-color: #7d8fa1;
}
/*# sourceMappingURL=zone-editor.component.css.map */
